import SetPartnerCodeForm from './SetPartnerCodeForm';

export default SetPartnerCodeForm;
